import { FormControlBase } from '../models/form-control-base';
import { FormControlTypeEnum } from '../models/form-control-type.enum';

export class FormControlTextarea extends FormControlBase<string> {
	public controlType = FormControlTypeEnum.Textarea;
}
